module.exports = __webpack_public_path__ + "img/tvinstall.d72e9a8d.png";